import React, { useState, useEffect } from 'react';
import '../CreateProduct.css';
import {
  makeStyles, Paper
} from '@material-ui/core';
import clsx from 'clsx';
import CustomAlert from '../../CustomAlert';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import { Helmet } from 'react-helmet';
import { parseSchemeMedicineExcelData } from '../../../mock/schemes';

const useStyles = makeStyles((theme) => ({
  root: {},
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'initial',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: '100%',
    padding: '20px'
  },
}));

const MAX_SEARCHES_PER_DAY = 10;
const SEARCH_LIMIT_BYPASS_USERS = [
  "cOn2A0wayefGD5WpRQKV0TbpRXH3",
  "upMp5iVxlcSuXO4fGdUVn1n2R5A3"
];

function SchemeList() {
  const classes = useStyles();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  const [openNotify, setOpenNotify] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [alertType, setAlertType] = useState('');
  const [MedicineSchemeEntry, setMedicineSchemeEntry] = useState(null);
  const [MedicineSchemeList, setMedicineSchemeList] = useState([]);
  const { userData } = CheckUserProvider();

  useEffect(() => {
    if (userData) {
      try {
        const getLocalSchemeMedicineList = parseSchemeMedicineExcelData();
        setMedicineSchemeList(getLocalSchemeMedicineList);
      } catch (error) {
        console.error("Error updating data:", error);
      }
    }
  }, [userData]);

  const handleOnSearch = (string, results) => {
    console.log('handleOnSearch');
  };

  const handleOnHover = (result) => {
    console.log('handleOnHover');
  };

  const handleOnSelect = (item) => {
    if (SEARCH_LIMIT_BYPASS_USERS.includes(userData?.uid)) {
      setMedicineSchemeEntry(item);
      return;
    }
  
    const today = new Date().toISOString().split("T")[0];
    const storedData = JSON.parse(localStorage.getItem("searchData")) || {};
  
    if (storedData.date !== today) {
      storedData.count = 0;
      storedData.date = today;
    }
  
    if (storedData.count >= MAX_SEARCHES_PER_DAY) {
      setOpenNotify(true);
      setAlertType("error");
      setNotificationMessage("You have reached the maximum search limit. Please try again tomorrow.");
      return;
    }
  
    storedData.count += 1;
    localStorage.setItem("searchData", JSON.stringify(storedData));
    setMedicineSchemeEntry(item);
  };

  const handleOnFocus = () => {
    console.log('Focused');
  };

  const formatResult = (item) => (
    <>
      <span style={{ display: 'block', textAlign: 'left' }}>
        {item.ProductName}
      </span>
    </>
  );

  return (
    <>
      <div className="createProduct rate-list mt-2">
        <Helmet>
          <meta name="description" content="Creating New Product And Sales page." />
          <title>Product Scheme Information List | Kaipsool Pharmatech</title>
        </Helmet>
        <Paper className={fixedHeightPaper}>
          <div className="row">
            <h5 className="mt-3 text-center">Scheme information for Chemist</h5>
            <div className="row mb-3">
              <div className="col-md-2 mb-2"></div>
              <div className="col-md-8 mb-2">
                <ReactSearchAutocomplete
                  items={MedicineSchemeList}
                  placeholder="Search Medicine..."
                  fuseOptions={{ keys: ['ProductName'] }}
                  resultStringKeyName="ProductName"
                  onSearch={handleOnSearch}
                  onHover={handleOnHover}
                  onSelect={handleOnSelect}
                  onFocus={handleOnFocus}
                  autoFocus
                  formatResult={formatResult}
                  styling={{
                    borderRadius: '8px',
                    zIndex: 1000,
                  }}
                />
              </div>
              <div className="col-md-2 mb-2"></div>
            </div>

            {MedicineSchemeEntry && (
              <div className="row mb-3 ml-5 table-overflow">
                <h6>Search Result:</h6>
                <table className="table">
                  <thead>
                    <tr>
                      <th><b>Product Name</b></th>
                      <th><b>Product Scheme</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{MedicineSchemeEntry?.ProductName}</td>
                      <td>{MedicineSchemeEntry?.ProductScheme}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </Paper>
      </div>
      <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType} notificationMessage={notificationMessage} />
    </>
  );
}

export default SchemeList;
